module.exports = __webpack_public_path__ + "img/nut_allergy.0cebe267.svg";